import type { TFunction } from 'i18next';

type BookingRateLimitModalProps = {
  retryAfterSec: number;
  t: TFunction;
  onClose: () => void;
  onRetry: () => void;
};

export function BookingRateLimitModal({ retryAfterSec, t, onClose, onRetry }: BookingRateLimitModalProps) {
  return (
    <div
      className="booking-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="booking-modal">
        <h2 className="booking-heading" style={{ margin: '0 0 var(--spacing-lg) 0' }}>
          {t('booking.rateLimit.title')}
        </h2>
        <p className="booking-text-md booking-color-muted" style={{ margin: '0 0 var(--spacing-xl) 0' }}>
          {t('booking.rateLimit.message')}{' '}
          <strong
            style={{
              fontSize: 'var(--font-size-xl)',
              color: 'var(--color-primary)',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {Math.floor(retryAfterSec / 60)}:{(retryAfterSec % 60).toString().padStart(2, '0')}
          </strong>
        </p>
        <div className="booking-gap-md" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onClose}
            className="booking-button"
            style={{
              flex: 1,
              backgroundColor: 'transparent',
              border: '1px solid var(--color-border)',
              color: 'var(--color-text-primary)',
            }}
          >
            {t('booking.rateLimit.close')}
          </button>
          <button
            type="button"
            onClick={onRetry}
            disabled={retryAfterSec > 0}
            className="booking-button booking-button-primary"
            style={{ flex: 1 }}
          >
            {t('booking.rateLimit.retry')}
          </button>
        </div>
      </div>
    </div>
  );
}
